/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetTaskQueryResponse, GetTaskPathParams, GetTask400, GetTask401, GetTask403, GetTask404, GetTask409, GetTask500 } from "../../types/planningTasksController/GetTask.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getTask } from "../../client/planningTasksController/getTask.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTaskQueryKey = (organizationId: GetTaskPathParams["organizationId"] | undefined, taskId: GetTaskPathParams["taskId"] | undefined) => [{ url: '/api/organizations/:organizationId/tasks/:taskId', params: {organizationId:organizationId,taskId:taskId} }] as const

export type GetTaskQueryKey = ReturnType<typeof getTaskQueryKey>

export function getTaskQueryOptions(organizationId: GetTaskPathParams["organizationId"] | undefined, taskId: GetTaskPathParams["taskId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getTaskQueryKey(organizationId, taskId)
        return queryOptions<GetTaskQueryResponse, ResponseErrorConfig<GetTask400 | GetTask401 | GetTask403 | GetTask404 | GetTask409 | GetTask500>, GetTaskQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && taskId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getTask(organizationId!, taskId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get task by ID
 * {@link /api/organizations/:organizationId/tasks/:taskId}
 */
export function useGetTask<TData = GetTaskQueryResponse, TQueryData = GetTaskQueryResponse, TQueryKey extends QueryKey = GetTaskQueryKey>(organizationId: GetTaskPathParams["organizationId"] | undefined, taskId: GetTaskPathParams["taskId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetTaskQueryResponse, ResponseErrorConfig<GetTask400 | GetTask401 | GetTask403 | GetTask404 | GetTask409 | GetTask500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getTaskQueryKey(organizationId, taskId)
         

         const query = useQuery({
          ...getTaskQueryOptions(organizationId, taskId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetTask400 | GetTask401 | GetTask403 | GetTask404 | GetTask409 | GetTask500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}